export { drawNetworkIcon, __networkAliasCount } from './glyph';
